import {getAppConfigVar} from '../config';
import ApiSubscriberInfoResponse from '../../types/ApiSubscriberInfoResponse';
import WateringAdviceSubscriber from '../../types/WateringAdviceSubscriber';


/**
 *
 */
export default class SubscriberUtils
{
	/**
	 *
	 */
	static getSubscriberInfo( token: string | null = null ): Promise<WateringAdviceSubscriber>
	{
		return new Promise( ( resolve, reject ) =>
		{
			const tokenString          = token ? token : this.getQueryParamToken();
			const wateringAdviceApiUrl = getAppConfigVar( 'wateringAdviceApiUrl' );

			if (!(typeof wateringAdviceApiUrl === 'string')) {
				reject();
				return;
			}

			const endpoint = wateringAdviceApiUrl + '/api/subscribers/info/?token=' + encodeURIComponent( tokenString );

			fetch( endpoint )
				.then( response => response.json() )
				.then( ( response: ApiSubscriberInfoResponse ) =>
				{
					if (response.success && response.subscriber) {
						resolve( response.subscriber );
					} else {
						reject();
					}
				} );
		} );
	}


	/**
	 *
	 */
	static getQueryParamToken()
	{
		const params = new URLSearchParams( window.location.search );
		const tkn    = params.get( 'tkn' );

		return tkn ? tkn.toString() : '';
	}

}